// extracted by css-extract-rspack-plugin
export default {"second_drawer":"second_drawer-UVfPUX","secondDrawer":"second_drawer-UVfPUX"};